<template>
    <div>
        <h3 class="is-size-3">Grado de Riesgo</h3>
        <p>
            <code><strong>POST</strong> {{ host }}/api/firaCreditRiskRating</code>
        </p>
        <br />
        <h5 class="is-size-6">Se busca obtener el grado de riesgo del cliente de acuerdo al porcentaje de reservas preventivas, según la Sección Quinta, en el artículo 129, de la Circular Única de Bancos.<br>
        El endpoint recibe 2 parámetros obligatorios:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>tipo</strong>
                    <ul>
                        <li>
                            <b>Descripción:</b> Es el tipo de crédito
                        </li>
                        <li>
                            <b>Requerido:</b> Si
                        </li>
                        <li>
                            <b>Tipo de dato:</b> String
                        </li>
                        <li>
                            <b>Valores permitidos:</b> NO REVOLVENTE, REVOLVENTE, HIPOTECARIA o COMERCIAL
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>valor</strong>
                    <ul>
                        <li>
                            <b>Requerido:</b> Si
                        </li>
                        <li>
                            <b>Tipo de dato:</b> Decimal
                        </li>
                        <li>
                            <b>Valores permitidos:</b> de 0 a 100, con 10 decimales permitidos
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">
            El endpoint recibe la solicitud en formato JSON:
        </h5>
        <pre>
            <code>
                {
                    "tipo": "COMERCIAL",
                    "valor": 0.9016
                }
            </code>
        </pre>
        <br />
        <h5 class="is-size-6">Respuesta exitosa:</h5>
        <pre>
            <code>
                {
                    "grado_riesgo": "A-2",
                    "tipo": "COMERCIAL",
                    "rango_inferior": "0.9000000001",
                    "rango_superior": "1.5000000000"
                }
            </code>
        </pre>
        <h5 class="is-size-6">Posibles respuestas fallidas:</h5>
        <pre>
            <code>
                {
                    "error": "No se encontró grado de riesgo"
                }
            </code>
            <strong>Explicación:</strong> No hay grado de riesgo para el valor enviado
        </pre>
        <br />
        <pre>
            <code>
                {
                    "error": "Discrepancia al obtener grado de riesgo, hay mas de 1 posible valor"
                }
            </code>
            <strong>Explicación:</strong> Se detectaron 2 grados de riesgo para el valor enviado
        </pre>
        <br />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>